import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SignOut from "./../auth/SignOut";
import TalaeraDefaultBackground from "./../TalaeraDefaultBackground/TalaeraDefaultBackground";
import PrivateRoute from "./PrivateRoute";
import TalaeraRoutes from "./TalaeraRoutes";
import UnauthRoutes from "./UnauthRoutes";

const AsyncCustomerServiceMonitoring = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminMonitoringShiftPage" */
      "./../../pages/admin/AdminMonitoring/AdminMonitoringShiftPage"
    )
);

const AsyncCustomerServiceSession = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSessionPage" */
      "./../../pages/admin/AdminSession/AdminSessionPage"
    )
);

export default class CustomerServiceRoutes extends Component {
  render() {
    return (
      <Routes key={this.props.location.pathname}>
        <Route
          path={TalaeraRoutes.ROOT.path}
          element={<Navigate to={TalaeraRoutes.CUSTOMERSERVICE_ROOT.path} replace />}
        />

        <Route
          path={TalaeraRoutes.CUSTOMERSERVICE_SESSION_DETAILS.path}
          element={
            <PrivateRoute
              component={AsyncCustomerServiceSession}
              permissions="customer-service"
              smallWindow={this.props.smallWindow}
            />
          }
        />

        <Route
          path={TalaeraRoutes.CUSTOMERSERVICE_ROOT.path}
          element={
            <PrivateRoute
              component={AsyncCustomerServiceMonitoring}
              permissions="customer-service"
              smallWindow={this.props.smallWindow}
            />
          }
        />

        <Route
          path={TalaeraRoutes.SIGN_OUT.path}
          element={
            <TalaeraDefaultBackground>
              <SignOut />
            </TalaeraDefaultBackground>
          }
        />

        <Route path={"*"} element={<UnauthRoutes showWrongLinkIfAuthenticated />} />
      </Routes>
    );
  }
}
